<template>
  <div :id="componentId" class="protips-block">
    <h1
      v-if="productData.howToMade_headingTitle"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="protip-heading-title"
    >
      {{ productData.howToMade_headingTitle }}
    </h1>
    <div
      v-for="(ingrediants, index) in productData.HowItsMadeProccess"
      :key="index"
      class="product-ingrediant-block"
    >
      <img
        v-if="ingrediants.process_icon"
        v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
        class="protip-icon"
        :src="ingrediants.process_icon.Src"
        :alt="ingrediants.process_icon.Alt"
      />
      <h2
        v-if="ingrediants.process_title"
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="protip-title"
      >
        {{ ingrediants.process_title }}
      </h2>
      <h3
        v-if="ingrediants.process_subTitle"
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="protip-subtitle"
      >
        {{ ingrediants.process_subTitle }}
      </h3>
      <img
        v-if="ingrediants.process_image"
        v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
        class="protip-image"
        :src="ingrediants.process_image.Src"
        :alt="ingrediants.process_image.Alt"
      />
      <div
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        :class="descriptionBlockStyle(ingrediants)"
      >
        <quote-box
          v-if="ingrediants.process_isDescriptionQuote"
          :content="ingrediants.process_description"
        ></quote-box>
        <slot v-else :name="ingrediants.process_id"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteBox from './quote-box.vue';

export default {
  name: 'how-its-made',
  components: {
    QuoteBox,
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'how-its-made',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
    descriptionBlockStyle(ingrediants) {
      const bgcolor = ingrediants.process_isBgDescriptionWhite ? 'desc-white-bg' : 'desc-grey-bg';
      const overlap = ingrediants.process_descriptionNotOverlap
        ? 'protip-content-block'
        : 'protip-content-block-overlap';
      return `${overlap} ${bgcolor}`;
    },
  },
};
</script>
